const LOCAL_API = "http://localhost:8000";
const LOCAL_WS = "ws://localhost:8000/ws/chat/";
const PROD_API = "https://api.murnau.rocks";
const PROD_WS = "wss://api.murnau.rocks/ws/chat/";

function onRemoteHost(): boolean {
  if (typeof window === "undefined") return false;
  return /(^|\.)(murnau\.rocks|vincent-gross\.de)$/.test(window.location.hostname);
}

/** localhost (bun or vue-nginx) → Docker FastAPI :8000. Live domain → live API. */
export function getApiBase(): string {
  if (onRemoteHost()) {
    if (typeof window !== "undefined" && /(^|\.)vincent-gross\.de$/.test(window.location.hostname)) {
      return "https://api.vincent-gross.de";
    }
    return PROD_API;
  }
  return LOCAL_API;
}

export function getWsChatBase(): string {
  if (onRemoteHost()) {
    if (typeof window !== "undefined" && /(^|\.)vincent-gross\.de$/.test(window.location.hostname)) {
      return "wss://api.vincent-gross.de/ws/chat/";
    }
    return PROD_WS;
  }
  return LOCAL_WS;
}
